import BaseService from "./geral/BaseService";

const base = "OrcamentoWebConsulta";

export default class OrcamentoConsultaService extends BaseService {
  constructor() {
    super(base);
  }

  Demonstrativo(documento="", dataFimServ="") {
      return super.httpGet(`/${base}/Demonstrativo?documento=${documento}&dtFimServ=${dataFimServ}`);
  }
  Detalhe(DetalheId="") {
      return super.httpGet(`/${base}/Detalhe/${DetalheId}`);
  }
  ExibirBoleto(Id="") {
      return super.httpGet(`/${base}/ExibirBoleto?orcamentoId=${Id}`);
  }
  RecuperarPix(Id="") {
    return super.httpGet(`/pix/RecuperarQrCode?OrcamentoId=${Id}`);
  }

  
  ListarSituacao() {
      return super.httpGet(`/${base}/ListarSituacao`);
  }
  ListarTipo() {
      return super.httpGet(`/${base}/ListarTipo`);
  }
  Listar(doc="", container="", razaoCliente="", nota="", tipo="", status="") {
    return super.httpGet(`/${base}/Listar?documento=${doc}&container=${container}&razaoCliente=${razaoCliente}&orcOuNotaId=${nota}&tipoOrcamento=${tipo}&status=${status}`);
  }
  Cancelar(orcamentoId="") {
      return super.httpPost(`/${base}/Cancelar?orcamentoId=${orcamentoId}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/OrcamentoConsultaService.js